import { Component, OnInit, ViewChild } from '@angular/core';
import { BackendService } from '../../../core/backend.service';
import { SnackService } from '../../../shared-services/snack.service';
import { NavigationService } from '../../../shared-services/navigation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Cliente } from '../../cliente.model';
import { OperationalOperacion } from '../operationalOperacion.model';
import { NgForm } from '@angular/forms';
import { DialogService } from '../../../shared-components/modals/dialog.service';
import { FormValidatorService } from '../../../shared-services/form-validator.service';
import { Operacion } from '../operacion.model';
import { Saldo } from '../../saldo.model';
import { Parametric } from '../../parametric.model';
import { ApiService } from '../../../core/api.service';
import { TipoOperacion } from '../tipoOperacion.model';
import { TipoMoneda } from '../tipoMoneda.model';
import { Precio } from '../../../core/precio.model';
import { Dolar } from '../../../core/dolar.model';

@Component({
  selector: 'app-operacion-add',
  templateUrl: './operacion-add.component.html',
  styleUrls: ['./operacion-add.component.scss']
})
export class OperacionAddComponent implements OnInit {

  cliente: Cliente;
  operacion: OperationalOperacion = new OperationalOperacion();
  validationFail = false;
  saldos: Saldo[];
  tiposOperaciones: Parametric[];
  isHD: boolean;

  private formasOperaciones: Parametric[];
  private tiposMonedas: Parametric[];
  TipoOperacion = new TipoOperacion();
  private TipoMoneda = new TipoMoneda();
  private precio: Precio;
  private dolar: Dolar = new Dolar();
  urlBack = '/clientes/ver-saldos/';

  @ViewChild('form') public operacionForm: NgForm;
  constructor(
    private router: Router,
    private snackService: SnackService,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private apiService: ApiService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
    private formValidatorService: FormValidatorService
  ) { }

  ngOnInit() {
    this.getPrecio();
    this.getSpread();
    this.getDolarCompra();
    this.getDolarVenta();

    this.route.data.subscribe(data => {
      this.cliente = data.cliente;
      this.saldos = data.saldos;
      this.operacion.cliente = this.cliente.id;
    });

    this.route.params.subscribe(params => {
      this.urlBack = '/clientes/ver-saldos/' + params.id;
    });

    this.getTiposMonedas();
    this.getTiposOperaciones();
    this.getFormasOperaciones();
  }

  async getTiposOperaciones() {
    this.tiposOperaciones = await this.apiService.get(Parametric, Parametric.path + 'tipos_operaciones/', null).toPromise();
  }
  async getFormasOperaciones() {
    this.formasOperaciones = await this.apiService.get(Parametric, Parametric.path + 'formas_operacion/', null).toPromise();
  }
  async getTiposMonedas() {
    this.tiposMonedas = await this.apiService.get(Parametric, Parametric.path + 'tipos_monedas/', null).toPromise();
  }

  async confirmSave() {
    if (this.validateForm()) {
      this.dialogService.confirm('Alta de operación',
      '¿Está seguro que desea guardar la operación?')
      .then( res => {
        if (res) {
          this.saveCliente(res);
        }
      });
    }
  }

  validateForm() {
    let validationsOK = false;
    if (this.formValidatorService.isFormValid(this.operacionForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }
    return validationsOK;
  }

  async saveCliente(res) {
    if (res) {
      this.snackService.spinner(true);
      try {
        await this.backendService.create(Operacion.path, this.operacion);
        this.snackService.success('Operación creada satisfactoriamente');
        this.router.navigate(['/clientes/ver-saldos/' + this.cliente.id]);
      } catch (ex) {
        if (ex[0]) {
          this.snackService.error(ex[0].details);
        } else if (ex.errors) {
          this.snackService.error(ex.errors[0].defaultMessage);
        } else {
          this.snackService.error(ex.message);
        }
      } finally {
        this.snackService.spinner(false);
      }
    }
  }

  async getPrecio() {
    this.precio = await this.apiService.get(Precio, Precio.path).toPromise();
  }

  async updatePrecio() {
    if (this.operacion.tipoOperacion === this.TipoOperacion.staticCompra) {
      this.changePrecio();
    } else {
      this.operacion.precio = null;
    }
  }

  async changePrecio() {
    // Si las monedas son iguales, no tiene sentido
    if (this.operacion.monedaDestino !== this.operacion.monedaOrigen) {
      // MONEDA DE ORIGEN DOLAR
      if (this.operacion.monedaOrigen === this.TipoMoneda.staticDolar) {
        // MONEDA DESTINO PESO
        if (this.operacion.monedaDestino === this.TipoMoneda.staticPeso) {
          this.operacion.precio = 1 / this.dolar.venta;
        }
        // MONEDA DESTINO BITCOIN
        if (this.operacion.monedaDestino === this.TipoMoneda.staticBitcoin) {
          this.operacion.precio = this.precio.lastSeller;
        }
      }

      // MONEDA DE ORIGEN PESO
      if (this.operacion.monedaOrigen === this.TipoMoneda.staticPeso) {
        // MONEDA DESTINO DOLAR
        if (this.operacion.monedaDestino === this.TipoMoneda.staticDolar) {
          this.operacion.precio = this.dolar.compra;
        }
        // MONEDA DESTINO BITCOIN
        if (this.operacion.monedaDestino === this.TipoMoneda.staticBitcoin) {
          this.operacion.precio = this.precio.lastSeller * this.dolar.venta;
        }
      }

      // MONEDA DE ORIGEN BITCOIN
      if (this.operacion.monedaOrigen === this.TipoMoneda.staticBitcoin) {
        // MONEDA DESTINO DOLAR
        if (this.operacion.monedaDestino === this.TipoMoneda.staticDolar) {
          this.operacion.precio = 1 / this.precio.lastBuyer;
        }
        // MONEDA DESTINO PESO
        if (this.operacion.monedaDestino === this.TipoMoneda.staticPeso) {
          this.operacion.precio = 1 / (this.precio.lastBuyer * this.dolar.compra);
        }
      }
    } else {
      this.operacion.precio = null;
    }
  }

  async getSpread() {
    this.operacion.cotizacion = await this.backendService.getSpread('/configuraciones/spread') as number;
  }

  async getDolarCompra() {
    this.dolar.compra = await this.backendService.getDolarCompra('/configuraciones/dolar_compra') as number;
  }

  async getDolarVenta() {
    this.dolar.venta = await this.backendService.getDolarVenta('/configuraciones/dolar_venta') as number;
  }

  async updateCantidad() {
    if (this.operacion.precio !== null) {
      this.operacion.cantidad = this.operacion.monto / (this.operacion.precio * (1 + this.operacion.cotizacion / 100));
    } else if (this.operacion.monto != null && this.operacion.monedaDestino != null) {
      this.operacion.cantidad = this.operacion.monto;
    }
  }

  async updateMonto() {
    if (this.operacion.precio !== null) {
      this.operacion.monto = this.operacion.cantidad * this.operacion.precio * (1 + this.operacion.cotizacion / 100);
    } else if (this.operacion.cantidad != null && this.operacion.monedaOrigen != null) {
      this.operacion.monto = this.operacion.cantidad;
    }
  }

  async cleanFields() {
    this.operacion.monedaDestino = NaN;
    this.operacion.monedaOrigen = NaN;
    this.operacion.monto = NaN;
    this.operacion.cantidad = NaN;
  }

  back() {
    this.navigationService.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/operaciones/operacion-add/operacion-add.component.ts